import { useEffect } from "react";
import { useConfig } from "../common/config";

export function useDocumentTitle(title: string | null) {
    const landName = useConfig(p => p.clientData.landName);
    useEffect(() => {
        document.title = landName + " " + (title != null ? title + " - Aesculap" : "Aesculap");
    }, [title, landName]);
}
